export default "__VITE_ASSET__DPESQdrT__"